import { ValidationError } from './validation-error';

export class ValidatedPhoto {
    private readonly _nativeFile: File;

    private readonly _validationError: ValidationError;

    public get hasValidationError(): boolean {
        return !!this.validationError;
    }

    public get validationError(): ValidationError {
        return this._validationError;
    }

    public get nativeFile(): File {
        return this._nativeFile;
    }

    public constructor(
        file: File,
        validationError?: ValidationError,
        public width?: number,
        public height?: number
    ) {
        this._nativeFile = file;
        this._validationError = validationError;
    }

    public withValidationError(validationError: ValidationError) {
        return new ValidatedPhoto(this.nativeFile, validationError);
    }

    public withDimensions(width: number, height: number) {
        return new ValidatedPhoto(
            this.nativeFile,
            this.validationError,
            width,
            height
        );
    }
}
